import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content pb-5" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row justify-content-center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Container',
  props: {
    col: { default: "col-12" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.col)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ])
    ])
  ]))
}
}

})